import React, { useEffect, useState } from 'react';

import {

  Box,

  Typography,

  Paper,

  Button,

  Grid,

  CircularProgress,

  Dialog,

  DialogContent,

} from '@mui/material';

import { useLocation, useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import api from '../../services/api';

import CreditCardIcon from '@mui/icons-material/CreditCard';

import TuneIcon from '@mui/icons-material/Tune';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import editWidget1 from '../../assets/edit-widget-1.png';

import editWidget2 from '../../assets/edit-widget-2.png';

import editWidget3 from '../../assets/edit-widget-3.png';



// Importar el componente de PlataformaSelector

import PlataformaSelector from '../../components/guias/PlataformaSelector';



const EditarWidget = () => {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const location = useLocation();

  

  const { service_id } = location.state || {};

  

  const [loading, setLoading] = useState(true);

  const [domain, setDomain] = useState('');

  const [widgetData, setWidgetData] = useState(null);

  

  // Estado para el modal de guías

  const [guidesModalOpen, setGuidesModalOpen] = useState(false);



  useEffect(() => {

    window.scrollTo(0, 0);

  }, []);



  useEffect(() => {

    const fetchWidgetData = async () => {

      try {

        const response = await api.get(`/service-details/${service_id}`);

        setDomain(response.data.domain || 'Widget');

        setWidgetData(response.data);

      } catch (error) {

        setDomain('Widget');

      } finally {

        setLoading(false);

      }

    };



    if (service_id) {

      fetchWidgetData();

    } else {

      setLoading(false);

    }

  }, [service_id]);



  const handleModifyPlan = () => {

    navigate('/dashboard/home');

  };



  const handleCustomizeWidget = () => {

    if (widgetData && widgetData.widget_configuration) {

      navigate('/dashboard/personalizar-widget', {

        state: {

          service_id,

          domain: widgetData.domain,

          autoDeploy: widgetData.widget_configuration.autoDeploy,

          color: widgetData.widget_configuration.color,

          defaultLanguage: widgetData.widget_configuration.defaultLanguage,

          iconPosition: widgetData.widget_configuration.iconPosition,

          iconSizeValue: widgetData.widget_configuration.iconSizeValue,

          iconType: widgetData.widget_configuration.iconType,

          mode: widgetData.widget_configuration.mode,

          windowPosition: widgetData.widget_configuration.windowPosition

        }

      });

    } else {

    }

  };



  // // Funciones para el modal de guías

  // const handleOpenGuides = () => {

  //   setGuidesModalOpen(true);

  // };



  const handleCloseGuides = () => {

    setGuidesModalOpen(false);

  };



  if (loading) {

    return (

      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

        <CircularProgress />

      </Box>

    );

  }



  return (

    <>

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Cabecera fija */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            width: "100%",

          }}

        >

          <Box sx={{ 

            display: { xs: "flex", sm: "flex" }, 

            flexDirection: "column", 

            flex: 1,

            ml: { xs: "50px", sm: "50px", md: 35.5 },

          }}>

            <Typography

              variant="h5"

              sx={{

                fontSize: { xs: "18px", sm: "16px", md: "14px", lg: "20px" },

                fontWeight: "medium",

                color: "#000",

              }}

            >

              {t("editWidget.title")} <span style={{ color: '#0F52BD' }}>{domain}</span>

            </Typography>



            <Typography

              variant="subtitle1"

              sx={{

                fontSize: { xs: "12px", sm: "15px", md: "14px" },

                color: "#666",

                mt: { xs: 0, md: 0.3 },

                display: { xs: "none", sm: "none", md: "none", lg: "block" },

              }}

            >

              {t("editWidget.subtitle")}

            </Typography>

          </Box>



          <Box

            sx={{

              display: "flex",

              gap: { xs: 1.5, sm: 2 },

              mr: { xs: 1.5, md: 5 },

              alignItems: "center",

            }}

          >

            <Box sx={{ display: { xs: "none", sm: "block" } }}>

            <Button

              variant="contained"

              onClick={() => navigate('/dashboard')}

              startIcon={<ArrowBackIcon />}

              sx={{

                textTransform: "none",

                fontWeight: "medium",

                backgroundColor: "#0F52BD",

                fontSize: { sm: "12px", md: "12px" },

                px: { sm: 1.5, md: 1.5 },

                py: { sm: 0.8, md: 0.8 },

                borderRadius: "8px",

              }}

            >

              {t("home.backToDashboard")}

            </Button>

            </Box>

          </Box>

        </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      {/* Contenido principal */}

      <Box sx={{ ml: { xs: -6, md: 0 } }}>

        <Box sx={{ paddingLeft: { xs: 6, md: 2 }, paddingRight: { xs: 0, md: 4 } }}>

          

          <Grid container spacing={4}>

            {/* Columna izquierda - Dos tarjetas */}

            <Grid item xs={12} md={7}>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                

                {/* Tarjeta 1: Modificar Plan */}

                <Paper

                  elevation={0}

                  sx={{

                    height: { xs: '180px', sm: '200px' },

                    boxShadow: '0px 4px 10px 0px rgba(98, 113, 137, 0.46)',

                    borderRadius: 2.5,

                    overflow: 'hidden'

                  }}

                >

                  <Box sx={{ display: 'flex', height: '100%' }}>

                    {/* Mitad izquierda - Texto */}

                    <Box sx={{ 

                      flex: 1, 

                      p: { xs: 1.5, sm: 2.5, md: 4 }, 

                      display: 'flex', 

                      flexDirection: 'column', 

                      justifyContent: 'space-between',

                      minHeight: 0

                    }}>

                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 0.5, sm: 1, md: 1.5 } }}>

                          <CreditCardIcon sx={{ 

                            fontSize: { xs: 20, sm: 24, md: 32 }, 

                            mr: { xs: 1, sm: 1.5, md: 2 }, 

                            color: '#0F52BD',

                            flexShrink: 0

                          }} />

                          <Typography variant="h5" sx={{ 

                            fontWeight: 'bold', 

                            fontSize: { xs: '14px', sm: '16px', md: '20px' }, 

                            color: '#000',

                            lineHeight: 1.2

                          }}>

                            {t("editWidget.modifyPlan")}

                          </Typography>

                        </Box>

                        <Typography variant="body1" sx={{ 

                          fontSize: { xs: '11px', sm: '12px', md: '14px' }, 

                          color: '#666',

                          lineHeight: 1.3,

                          overflow: 'hidden',

                          textOverflow: 'ellipsis',

                          display: '-webkit-box',

                          WebkitLineClamp: { xs: 2, sm: 3 },

                          WebkitBoxOrient: 'vertical'

                        }}>

                          {t("editWidget.modifyPlanDescription")}

                        </Typography>

                      </Box>

                      

                      <Button

                        variant="contained"

                        onClick={handleModifyPlan}

                        sx={{

                          backgroundColor: '#0F52BD',

                          color: 'white',

                          textTransform: 'none',

                          fontWeight: 'medium',

                          fontSize: { xs: '11px', sm: '12px', md: '14px' },

                          px: { xs: 1.5, sm: 2, md: 3 },

                          py: { xs: 0.3, sm: 0.4, md: 0.5 },

                          borderRadius: '5px',

                          alignSelf: 'flex-start',

                          '&:hover': {

                            backgroundColor: '#0d47a1'

                          },

                          mt: { xs: 0.5, sm: 1, md: 1.5 },

                          minWidth: 'auto',

                          flexShrink: 0

                        }}

                      >

                        {t("editWidget.edit")}

                      </Button>

                    </Box>

                    

                    {/* Mitad derecha - Imagen */}

                    <Box sx={{ 

                      flex: 1, 

                      position: 'relative',

                      backgroundColor: '#F3F3F3',

                      display: 'flex',

                      alignItems: 'center',

                      justifyContent: 'center',

                      p: 1

                    }}>

                      <Box

                        component="img"

                        src={editWidget1}

                        alt="Modificar Plan"

                        sx={{

                          width: '100%',

                          height: '100%',

                          objectFit: 'contain',

                          borderRadius: '8px'

                        }}

                      />

                    </Box>

                  </Box>

                </Paper>



                {/* Tarjeta 2: Personalizar Widget */}

                <Paper

                  elevation={0}

                  sx={{

                    height: { xs: '180px', sm: '200px' },

                    boxShadow: '0px 4px 10px 0px rgba(98, 113, 137, 0.46)',

                    borderRadius: 2.5,

                    overflow: 'hidden'

                  }}

                >

                  <Box sx={{ display: 'flex', height: '100%' }}>

                    {/* Mitad izquierda - Texto */}

                    <Box sx={{ 

                      flex: 1, 

                      p: { xs: 1.5, sm: 2.5, md: 4 }, 

                      display: 'flex', 

                      flexDirection: 'column', 

                      justifyContent: 'space-between',

                      minHeight: 0

                    }}>

                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 0.5, sm: 1, md: 1.5 } }}>

                          <TuneIcon sx={{ 

                            fontSize: { xs: 20, sm: 24, md: 32 }, 

                            mr: { xs: 1, sm: 1.5, md: 2 }, 

                            color: '#0F52BD',

                            flexShrink: 0

                          }} />

                          <Typography variant="h5" sx={{ 

                            fontWeight: 'bold', 

                            fontSize: { xs: '14px', sm: '16px', md: '20px' }, 

                            color: '#000',

                            lineHeight: 1.2

                          }}>

                            {t("editWidget.customizeWidget")}

                          </Typography>

                        </Box>

                        <Typography variant="body1" sx={{ 

                          fontSize: { xs: '11px', sm: '12px', md: '14px' }, 

                          color: '#666',

                          lineHeight: 1.3,

                          overflow: 'hidden',

                          textOverflow: 'ellipsis',

                          display: '-webkit-box',

                          WebkitLineClamp: { xs: 2, sm: 3 },

                          WebkitBoxOrient: 'vertical'

                        }}>

                          {t("editWidget.customizeWidgetDescription")}

                        </Typography>

                      </Box>

                      

                      <Button

                        variant="contained"

                        onClick={handleCustomizeWidget}

                        sx={{

                          backgroundColor: '#0F52BD',

                          color: 'white',

                          textTransform: 'none',

                          fontWeight: 'medium',

                          fontSize: { xs: '11px', sm: '12px', md: '14px' },

                          px: { xs: 1.5, sm: 2, md: 3 },

                          py: { xs: 0.3, sm: 0.4, md: 0.5 },

                          borderRadius: '5px',

                          alignSelf: 'flex-start',

                          '&:hover': {

                            backgroundColor: '#0d47a1'

                          },

                          mt: { xs: 0.5, sm: 1, md: 1.5 },

                          minWidth: 'auto',

                          flexShrink: 0

                        }}

                      >

                        {t("editWidget.edit")}

                      </Button>

                    </Box>

                    

                    {/* Mitad derecha - Imagen */}

                    <Box sx={{ 

                      flex: 1, 

                      position: 'relative',

                      backgroundColor: '#F3F3F3',

                      display: 'flex',

                      alignItems: 'center',

                      justifyContent: 'center',

                      p: 1

                    }}>

                      <Box

                        component="img"

                        src={editWidget2}

                        alt="Personalizar Configuración"

                        sx={{

                          width: '97%',

                          height: '97%',

                          objectFit: 'contain',

                          borderRadius: '8px'

                        }}

                      />

                    </Box>

                  </Box>

                </Paper>

              </Box>

            </Grid>



            {/* Columna derecha - Imagen */}

            <Grid item xs={12} md={5}>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                <Box

                  component="img"

                  src={editWidget3}

                  alt="Configuración del Widget"

                  sx={{

                    width: '100%',

                    height: { xs: 'auto', md: '445px' },

                    objectFit: { xs: 'contain', md: 'cover' },

                    borderRadius: 2.5,

                    cursor: 'pointer',

                    marginTop:'-6px'

                  }}

                />

              </Box>

            </Grid>

          </Grid>

        </Box>

      </Box>

    </Box>



      {/* Modal de Guías de Implementación */}

      <Dialog 

        open={guidesModalOpen} 

        onClose={handleCloseGuides} 

        fullWidth 

        maxWidth="lg"

        PaperProps={{

          sx: {

            borderRadius: 3,

            p: 0,

            m: 0,

            overflow: 'hidden',

            '& .MuiDialogContent-root': {

              padding: 0,

              margin: 0,

            }

          }

        }}

      >

        <DialogContent sx={{ 

          padding: 0, 

          margin: 0,

          '&:first-of-type': {

            paddingTop: 0

          }

        }}>

          <PlataformaSelector />

        </DialogContent>

      </Dialog>

    </>

  );

};



export default EditarWidget;
